import React from 'react';

const Card = ({ 
  children, 
  className = '', 
  title, 
  subtitle, 
  footerContent,
  compact = false 
}) => {
  return (
    <div className={`bg-white rounded-lg shadow-sm overflow-hidden ${className}`}>
      {(title || subtitle) && (
        <div className={`px-6 ${compact ? 'py-3' : 'py-4'} border-b border-gray-200`}>
          {title && <h3 className="text-lg font-medium text-gray-900">{title}</h3>}
          {subtitle && <p className="mt-1 text-sm text-gray-500">{subtitle}</p>}
        </div>
      )}
      
      <div className={`${compact ? 'px-4 py-3' : 'px-6 py-4'}`}>
        {children}
      </div>
      
      {footerContent && (
        <div className={`px-6 ${compact ? 'py-3' : 'py-4'} bg-gray-50 border-t border-gray-200`}>
          {footerContent}
        </div>
      )}
    </div>
  );
};

export default Card;